export default [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/index") ///* webpackChunkName: 'Index' */"@/views/index"
  },
  {
    path: "/login",
    name: "Login",
    meta: {
        keepAlive: true
    },
    component: () => import("@/views/login.vue")
  },
  {
    path: "/user",
    name: "User",
    component: () => import("@/views/user")
  },
  {
    path: "/search_list",
    name: "GoodsList",
    component: () => import("@/views/goods/list")
  },
  {
    path: "/classification_list",
    name: "Classes",
    component: () => import("@/views/goods/classes")
  },
  {
    path: "/transaction_list",
    name: "Trade",
    component: () => import("@/views/trade/list")
  },
  {
    path: "/goods_list",
    name: "MonitorGoods",
    component: () => import("@/views/monitor/goods")
  },
  {
    path: "/people_list",
    name: "MonitorPerson",
    component: () => import("@/views/monitor/person")
  },
  {
    path: "/operation_list",
    name: "Operation",
    component: () => import("@/views/system/operation_list")
  },
  {
    path: "/sys_user_list",
    name: "UserList",
    component: () => import("@/views/system/sys_user_list")
  },
  {
    path: "/organization_man",
    name: "OrganizationMan",
    component: () => import("@/views/system/organization_man")
  },
  {
    path: "/config",
    name: "SystemConfig",
    component: () => import("@/views/system/config")
  },
  {
    path: "/role_man",
    name: "RoleMan",
    component: () => import("@/views/system/role_man")
  },
  {
    path: "/menu_man",
    name: "MenuMan",
    component: () => import("@/views/system/menu_man")
  },
  {
    path: "*",
    name: "notFound",
    component: () => import("@/views/404.vue")
  },
  {
    path: "/subaccount_list",
    name: "SubAccountList",
    component: () => import("@/views/subaccount/index")
  },
  {
    path: "/idcardcertification",
    name: "idcardcertification",
    component: () => import("@/views/profile/idcardcertification")
  },
  {
    path: "/password",
    name: "password",
    component: () => import("@/views/profile/password")
  },
  {
    path: "/changephone",
    name: "changephone",
    component: () => import("@/views/profile/changephone")
  },
  {
    path: "/personaldetail",
    name: "personaldetail",
    component: () => import("@/views/profile/details")
  },
  {
    path: "/addressbook_list",
    name: "AddressBookList",
    component: () => import("@/views/addressbook/index")
  },
  {
    path: "/message_list",
    name: "MessageList",
    component: () => import("@/views/message/index")
  },
  {
    path: "/crontab_export",
    name: "CrontabExport",
    component: () => import("@/views/crontab/export")
  },
  {
    path: "/crontab_import",
    name: "CrontabImport",
    component: () => import("@/views/crontab/import")
  },
  {
    path: "/notice_list",
    name: "NoticeList",
    component: () => import("@/views/notice/list")
  },
  
];
